/**
 * @generated SignedSource<<c7a27075866ba11182dc54f2e43c7f7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type CodeScanningSecurityAlertStatus = "DISMISSED" | "FIXED" | "OPEN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type LinkedSecurityAlertIcon$data = {
  readonly status: CodeScanningSecurityAlertStatus | null | undefined;
  readonly " $fragmentType": "LinkedSecurityAlertIcon";
};
export type LinkedSecurityAlertIcon$key = {
  readonly " $data"?: LinkedSecurityAlertIcon$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedSecurityAlertIcon">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LinkedSecurityAlertIcon",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "CodeScanningSecurityAlert",
  "abstractKey": null
};

(node as any).hash = "544d69350e9c1cbd71f4580ad9aa0bf6";

export default node;
